<template>
  <div style="display: inline-block;margin: 10px;">
    <!-- :style="[{color: `${ color }`}]" -->
    <template>
      <el-tree ref="tree" @check="currentChecked" :data="data" show-checkbox node-key="NodeID" :default-checked-keys="menuIds"  :props="{  value: 'NodeID', label: 'NodeName' , children: 'Nodes' }">
      </el-tree>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    // 颜色
    color: {
      type: String,
      default: '#000'
    },
    // 
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '32px'
    },
    title: {
      type: String,
      default: ''
    },
    fontSize: {
      type: String,
      default: '2px'
    },
    // tree数据集
    data: {
      type: Array,
      default: [],

    },
	menuIds: {
      type: Array,
      default: [],

    },
  },
  data: function(){
	  return {
		 reftree: Object
	  }
  },
  created() {
	  //console.log(this.menuIds,'id')
	  
  },
  mounted() {
	this.reftree = this.$refs.tree
  },
  methods: {
    currentChecked(nodeObj, SelectedObj) {
		let selectpar = {
			SelectedObj: SelectedObj,
			checkedKeys: SelectedObj.checkedKeys,
			checkedNodes: SelectedObj.checkedNodes
		}
		
		// //console.log(SelectedObj)
		// //console.log(SelectedObj.checkedKeys)
      this.$emit('currentChecked',selectpar)
    }
  }
}
</script>

<style lang="less">
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #e71d43 !important;
  background-color: #e71d43 !important;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #e71d43 !important;
}
.el-checkbox__inner:hover {
  border-color: #e71d43 !important;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #e71d43 !important;
}
.el-tree-node:focus > .el-tree-node__content {
  background-color: #f5f5f5 !important;
}
.el-tree-node__content {
  width: 360px;
}
</style>
